import { Component, ViewChild } from '@angular/core';
import { IonicPage, NavParams, TextInput, ViewController } from 'ionic-angular';

import { AnalyticsProvider } from '../../../providers/analytics/analytics';
import { LoadingAlertProvider } from '../../../providers/loading-alert/loading-alert';
import { TypedFlow } from '../typed-flow/typed-flow';
import { UserProvider } from '../../../providers/user/user';

@IonicPage()
@Component({
  selector: 'page-login-flow',
  templateUrl: 'login-flow.html',
})
export class LoginFlowPage extends TypedFlow {
  @ViewChild('inputPin') inputPin: TextInput;

  phone: string = '';
  pin: string = '';

  constructor(
    navParams: NavParams,
    private viewController: ViewController,
    private userService: UserProvider,
    private loadingAlertCrtl: LoadingAlertProvider,
    private analytics: AnalyticsProvider
  ) {
    super();
    this.pageSelector = 'page-login-flow';
    this.phone = navParams.get('phone');
  }

  ionViewDidLoad() {
    this.analytics.trackView('LoginFlowPage');
    this.start();
    setTimeout(() => {
      this.inputPin.setFocus();
    }, 600);
  }

  login() {
    this.loadingAlertCrtl.showLoaderWithText('Logging In');
    this.userService
      .login(this.phone, this.pin)
      .finally(() => this.loadingAlertCrtl.dismissLoader())
      .subscribe(
        data => {
          this.viewController.dismiss(data);
        },
        error => {
          console.log('error logging in', error);
          this.loadingAlertCrtl.presentAlert(null, 'That pin is incorrect.');
        }
      );
  }

  formValidates() {
    return this.phone && this.pin;
  }

  // Actions

  didTapDismiss() {
    this.viewController.dismiss();
  }

  didTapBack() {
    this.back();
  }

  didTapLogin() {
    this.login();
  }
}



// WEBPACK FOOTER //
// ./src/pages/flows/login-flow/login-flow.ts